import $ from 'jquery';
import 'slick-carousel';
import lozad from 'lozad';
// import "../../assets/scripts/js/modernizer.js";

$(function () {
  "use strict";

  'use strict';

  // Slick sliders
  $('.ImageGalleryHorizontal-carousel').on('init', function (event, slick) {
    // console.log("initialized");
    // AOS.init();
    const observer = lozad(); // lazy loads elements with default selector as ".lozad"
    observer.observe();

  });
  $('.ImageGalleryHorizontal-carousel').slick({
    dots: false,
    arrows: true,
    // infinite: true,
    // cssEase: 'linear',
    // speed: 300,
    adaptiveHeight: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    prevArrow: '<span class="fas fa-chevron-double-left"></span>',
    nextArrow: '<span class="fas fa-chevron-double-right"></span>',
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1
        }
      }
    ]

  });

});

import "../../node_modules/slick-carousel/slick/slick.css";
import "../../node_modules/slick-carousel/slick/slick-theme.css";
